module.exports = __webpack_public_path__ + "media/icons/contact-9ebdb601.svg";